import { render, staticRenderFns } from "./ListImovelPage.vue?vue&type=template&id=4156284c&"
import script from "./ListImovelPage.vue?vue&type=script&lang=js&"
export * from "./ListImovelPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports